import React from "react";
import Container from "./containerUserFeedBack";
import "./feedback.css";

class UserContainer extends React.Component {
  render() {
    const { isMobile ,logo} = this.props;
    return (
      <Container isMobile={isMobile} logo={logo}>
        <div className={isMobile ? "containerSM" : "containerMD"}>
          <h4 className={isMobile ? "regretTextSM" : "regretTextMD"}>WE REGRET THAT SOMETHING DIDN'T WORK</h4>

          <div className="box">
            <h4 className={isMobile ? "regretSubTextSM" : "regretSubTextMD"}>
              We will get in touch with you to understand what went wrong and how we can fix it
            </h4>

            <a href="https://www.daffodilsw.com/" style={{ textDecoration: "none" }}>
              <a href="https://www.daffodilsw.com/" style={{ textDecoration: "none" }}>

                <div className="submitButton">
                  <div className="submitText">Done</div>
                </div>
              </a>
            </a>
          </div>
        </div>
      </Container>
    );
  }
}

export default UserContainer;
